import React, { Component } from 'react'
import autoBind from 'react-autobind'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { bindActionCreators } from 'redux'
import { Container, Image, Segment } from 'semantic-ui-react'

import back from '../../assets/images/angle-fuchsia.png'
import Modules from '../common/modules'
import CompletedExercises from '../common/completed-exercises'
import { tr } from '../../helpers/languages'
import { send } from '../../helpers/requests'
import { actions as participants } from '../../store/actions/participants'

class ParticipantExercises extends Component {
    constructor (props) {
        super(props)
        this.state = {
            exercises: [],
            moodBoosters: []
        }
        autoBind(this)
    }

    componentDidMount () {
        // Fetch the exercises.
        this.setState({ exercises: [], moodBoosters: [] })
        this.fetchExercises(this.props.module)
        this.fetchMoodBoosters(this.props.module)
        document.getElementById('completed-exercises').scrollTop = 0
    }

    componentWillReceiveProps (nextProps) {
        if (this.props.module !== nextProps.module) {
            // Fetch the exercises.
            this.setState({ exercises: [], moodBoosters: [] })
            this.fetchExercises(nextProps.module)
            this.fetchMoodBoosters(nextProps.module)
            document.getElementById('completed-exercises').scrollTop = 0
        }
    }

    // Fetches the participant's exercises for the given module.
    fetchExercises (module) {
        if (!module) {
            return
        }
        // eslint-disable-next-line no-console
        console.log('Fetch exercises.')
        send({
            method: 'GET',
            tokens: this.props.userTokens,
            url: `/patients/${this.props.match.params.id}/exercises/${module}`
        })
            .then((response) => {
                // eslint-disable-next-line no-console
                console.log('Fetched exercises.')
                this.setState({
                    exercises: response.data.filter((e) => { return e.id && e.status && e.title && e.type })
                })
            })
            .catch((error) => {
                // Failed to fetch exercises.
                // eslint-disable-next-line no-console
                console.error('Failed to fetch exercises.', error)
                // Hide the error.
                this.setState({ exercises: [] })
            })
    }

    // Fetches the participant's exercises for the given module.
    fetchMoodBoosters (module) {
        if (!module) {
            return
        }
        // eslint-disable-next-line no-console
        console.log('Fetch moodboosters.')
        send({
            method: 'GET',
            tokens: this.props.userTokens,
            url: `/patients/${this.props.match.params.id}/moodboosters/${module}`
        })
            .then((response) => {
                // eslint-disable-next-line no-console
                console.log('Fetched moodboosters.')
                this.setState({
                    moodBoosters: response.data
                })
            })
            .catch((error) => {
                // Failed to fetch exercises.
                // eslint-disable-next-line no-console
                console.error('Failed to fetch moodboosters.', error)
                // Hide the error.
                this.setState({ moodBoosters: [] })
            })
    }

    // Changes to the module with the given ID.
    changeModule (module) {
        this.props.changeLocation({ module })
    }

    render () {
        return (
            <Container className='participant-exercises'>
                <Segment
                    className='navigation-item'
                    onClick={(_e) => { this.props.onChangeSubsection(undefined) }}
                >
                    <Image src={back}/>
                    {tr('EXERCISES')}
                </Segment>
                <Modules
                    language={this.props.language}
                    timezone={this.props.timezone}
                    onChangeModule={(module) => { this.changeModule(module) }}
                />
                <CompletedExercises
                    exercises={this.state.exercises}
                    moodBoosters={this.state.moodBoosters}
                    onClickOnMoodJournals={() => { this.props.onChangeSubsection('journals', this.props.module) }}
                />
            </Container>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        language: state.settings.language,
        module: state.participants.location.module,
        timezone: state.settings.timezone,
        userTokens: state.users.userTokens
    }
}

const mapDispatchToProps = (dispatch) => {
    const _participants = bindActionCreators(participants, dispatch)
    return {
        changeLocation: _participants.changeLocation
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ParticipantExercises))



// WEBPACK FOOTER //
// ./src/components/participant-exercises/index.js